import { Base } from './_base.model';

export class SpeakerApprovalGroupClientLevel extends Base {
  id: number;
  speaker_approval_group_id: number;
  client_level_id: string;
  client_sub_level_id: string;
  rank: number;
  pending_status_label: string;
}
